import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';
import { Toast } from '../../../../../Notification';
import getOffsetTime from '../../../../../../utils/getOffsetTime';

export const logStart = async ({ userId, resourceName, day, logJobStart }) => {
  const operation = 1; // 1 = create/update
  try {
    await logJobStart(userId, operation);
  }
  catch (error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Start Error",
        description: `For [${resourceName} on ${day}]: ${parseError(error)}`
      };
      Toast(notification);
    }
  }
}

export const logFinish = async ({ resourceName, logControlId, jobId, day, logJobFinish }) => {
  try {
    await logJobFinish(logControlId, jobId);
  }
  catch (error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Finish Error",
        description: `For [${resourceName} on ${day}]: ${parseError(error)}`
      };
      Toast(notification);
    }
  }
}


export const updateJobElement = async ({ finalFormValidation, logControlId, state, userId, updateState, editJobElement, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const { itemDetails } = state;
  const { jobElementId, jobId, tourId, resourceId, resourceName, executingBranchId, serviceId, relatedServiceId,
    status, startRequest, endRequest, timeZoneId, orderingUserId, updatingUserId, descriptionComment,
    approverComment, employeeComment, schedulerComment, isAnUpgrade, overtime, activityType, overtimeType, overtimeReason, 
    costObject, jobSalaryUpgradeId, hourlyActivityRateFlag, rate, nabetTracker, eventNote, skillShowId, skillFacilityId, chgTz
  } = itemDetails;
  const { costObjectId, costObjectTypeId } = costObject;
  let { assignmentStartTime, assignmentEndTime } = itemDetails;

  // adjust time back to utc before saving
  let timeZoneOffset = getOffsetTime(assignmentStartTime._d);
  assignmentStartTime = moment(assignmentStartTime).clone();
  assignmentStartTime = assignmentStartTime;
  assignmentEndTime = moment(assignmentEndTime).clone();
  assignmentEndTime = assignmentEndTime;
  const parameters = {
    assignmentId: jobElementId,
    jobId,
    tourId,
    resourceId,
    executingBranchId,
    serviceId,
    relatedServiceId,
    status,
    startRequest,
    endRequest,
    startActual: assignmentStartTime.format(),
    endActual: assignmentEndTime.format(),
    timeZoneId,
    orderingUserId,
    updatingUserId,
    descriptionComment: descriptionComment || ' ',
    approverComment: approverComment || ' ',
    employeeComment: employeeComment || ' ',
    schedulerComment: schedulerComment || ' ',
    isAnUpgrade,
    logControlId,
    activityType,
    overtime: overtime || false, // added
    overtimeType: overtimeType || 0,
    overtimeReason: overtimeReason || null,
    costObjectId,
    costObjectTypeId,
    jobSalaryUpgradeId,
    hourlyActivityRateFlag,
    rate, // added
    nabetTracker: nabetTracker || 0,
    eventNote: eventNote || ' ',
    skillShowId: skillShowId || 0,
    skillFacilityId: skillFacilityId || 0,
    chgTz: chgTz || 0
  };

  // store assignment parameters for optimistic re-ender
  itemDetails.assignmentParams = parameters;
  await updateState({ itemDetails });
  // update job element
  const date = moment(assignmentStartTime).format('M/D/YYYY (ddd)');
  let notification = { type: 'success', message: 'Assignment Updated', description: `For ${resourceName} on ${date}` };
  try {
    await editJobElement(parameters);
  }
  catch (error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editJobElement',
          message: parseError(error)
        }
      });
      notification = {
        type: 'error',
        message: "Updating Assignment Failed",
        description: `For [${resourceName} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  updateState({
    crudLoading: false // allows page refresh after updateJobElement completes
  });
  if (refreshPage !== undefined) { refreshPage(); }
}

export default updateJobElement;


// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/assignment/updateAssignment.js